import { IJobTitleState } from 'store/types';
import { appConfig } from '../config/app';
import { ApiQueryOperator, IApiList, IEmployee } from '../types';
import { ApiClient, IApiQueryOptions } from './ApiClient';

export const Organizations = {
  getJobs: (orgId: string, includeInactive?: boolean, options?: IApiQueryOptions) =>
    ApiClient.get<IApiList<IJobTitleState>>(`${appConfig.API_BASE_URL}/v1/orgs/${orgId}/jobs`, {
      ...options,
      limit: 0,
      ...(!includeInactive && { q: [{ key: 'count', operator: ApiQueryOperator.gt, value: '0' }] }),
    }),
  listEmployees: (orgId: string, options?: IApiQueryOptions) => ApiClient.get<IApiList<IEmployee>>(`${appConfig.API_BASE_URL}/v1/orgs/${orgId}/employees`, options),
};
